import { render } from "./change-password.html?vue&type=template&id=6873111e&scoped=true&ts=true"
import script from "./change-password.ts?vue&type=script&lang=ts"
export * from "./change-password.ts?vue&type=script&lang=ts"

import "./change-password.scss?vue&type=style&index=0&id=6873111e&scoped=true&lang=scss"

import exportComponent from "C:\\Desarrollo\\Proyectos\\Codigo\\Helpharma\\Seguridad\\seguridad-adminlte-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6873111e"]])

export default __exports__